import { render } from "./MigrateWizard.vue?vue&type=template&id=4ecf9b9a&scoped=true"
import script from "./MigrateWizard.vue?vue&type=script&lang=js"
export * from "./MigrateWizard.vue?vue&type=script&lang=js"

import "./MigrateWizard.vue?vue&type=style&index=0&id=4ecf9b9a&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecf9b9a"]])

export default __exports__